import { Component } from 'react';
import { Container, Row } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import NonPpcMcSettingsForm from './non-ppc-mc-settings-form';
import ExportDateForm from './export-date-form';
import PageDivider from '../../common/divider';

class NonPpcMcSettings extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <Container fluid >
        <Row>
          <PageTitle>
            Mini Chain Invoice Payments
          </PageTitle>
          <NonPpcMcSettingsForm />
          <PageDivider />
          <ExportDateForm />
        </Row>
      </Container>
    );
  }
}

export default NonPpcMcSettings;
